import { getContentRelative } from '@/api';

export default {
  namespaced: true,
  state: {
    recommendList: [],
    loadRecommend: false,
  },
  getters: {},
  mutations: {
    PUSH_recommend(state, item) {
      state.recommendList.push(...item);
      state.loadRecommend = false;
    },
    CLEAR_recommend(state) {
      state.loadRecommend = true;
      state.recommendList = [];
    },
  },
  actions: {
    async getRecomendList({ commit }, params) {
      const { data } = await getContentRelative(params).catch(() => ({data: []}));
      commit('PUSH_recommend', data);
      return data
    },
  },
};
